document.addEventListener('DOMContentLoaded', function () {
  const solarScreen = document.querySelector('.solar-screen');

  if (!solarScreen) {
    return;
  }

  const vehicleButtons = solarScreen.querySelectorAll('[data-vehicle]');
  const priceButtons = solarScreen.querySelectorAll('.ss-price-option');
  const nonCarButtons = solarScreen.querySelectorAll('.ss-non-car-continue');
  const locationButtons = solarScreen.querySelectorAll('.ss-location-option');

  const carOptions = solarScreen.querySelector('[data-car-options]');
  const caravanOptions = solarScreen.querySelector('[data-caravan-options]');
  const boatOptions = solarScreen.querySelector('[data-boat-options]');
  const locationStep = solarScreen.querySelector('[data-location-step]');

  const bookingContinue = solarScreen.querySelector('[data-booking-continue]');
  const showCalendarButton = solarScreen.querySelector('[data-show-calendar]');

  const calendarWrapper = solarScreen.querySelector('[data-booking-calendar]');
  const workshopCalendar = solarScreen.querySelector(
    '[data-calendar-type="workshop"]'
  );
  const calloutCalendar = solarScreen.querySelector(
    '[data-calendar-type="callout"]'
  );
  const calendarDescription = solarScreen.querySelector(
    '[data-calendar-description]'
  );

  const summaryVehicle = solarScreen.querySelector('[data-summary-vehicle]');
  const summaryPackage = solarScreen.querySelector('[data-summary-package]');
  const summaryPrice = solarScreen.querySelector('[data-summary-price]');
  const summaryLocation = solarScreen.querySelector('[data-summary-location]');
  const summaryFee = solarScreen.querySelector('[data-summary-fee]');

  const state = {
    screens: { windscreens: null, windows: null },
    vehicle: null,
    vehicleLabel: null,
    package: null,
    packageIntakeValue: null,
    price: null,
    location: null,
    bookingFee: null,
    bookingType: null
  };


  /* ========================================
     HELPERS
     ======================================== */

  function clearSelected(elements) {
    elements.forEach(function (element) {
      element.classList.remove('is-selected');
      element.setAttribute('aria-pressed', 'false');
    });
  }


  function hideElement(element) {
    if (element) {
      element.hidden = true;
    }
  }


  function showElement(element) {
    if (element) {
      element.hidden = false;
    }
  }


  function hideVehicleOptions() {
    hideElement(carOptions);
    hideElement(caravanOptions);
    hideElement(boatOptions);
  }


  function hideCalendars() {
    hideElement(calendarWrapper);
    hideElement(workshopCalendar);
    hideElement(calloutCalendar);
  }


  function formatPrice(price, vehicle) {
    if (!price) {
      return '—';
    }

    if (price === 'TBC') {
      return 'Price on measure';
    }

    if (vehicle === 'caravan' || vehicle === 'boat') {
      return 'From $' + price;
    }

    return 'From $' + price;
  }


  function updateSummary() {
    if (summaryVehicle) {
      summaryVehicle.textContent = state.vehicleLabel || '—';
    }

    if (summaryPackage) {
      summaryPackage.textContent = state.package || '—';
    }

    if (summaryPrice) {
      summaryPrice.textContent = formatPrice(state.price, state.vehicle);
    }

    if (summaryLocation) {
      summaryLocation.textContent = state.location || '—';
    }

    if (summaryFee) {
      summaryFee.textContent = state.bookingFee
        ? '$' + state.bookingFee
        : '—';
    }
  }


  function resetAfterVehicleChange() {
    state.screens = { windscreens: null, windows: null };
    clearSelected(nonCarButtons);
    state.package = null;
    state.packageIntakeValue = null;
    state.price = null;
    state.location = null;
    state.bookingFee = null;
    state.bookingType = null;

    clearSelected(priceButtons);
    clearSelected(locationButtons);

    hideElement(locationStep);
    hideElement(bookingContinue);

    hideCalendars();

    updateSummary();
    preselectScreenPackage(document);
  }


  function showLocationStep() {
    showElement(locationStep);
  }


  function isReadyToBook() {
    return Boolean(
      state.vehicle &&
      state.package &&
      state.location &&
      state.bookingFee &&
      state.bookingType
    );
  }


  function updateBookingButton() {
    if (isReadyToBook()) {
      showElement(bookingContinue);
    } else {
      hideElement(bookingContinue);
      hideCalendars();
    }
  }


  function scrollToElement(element, block) {
    if (!element) {
      return;
    }

    element.scrollIntoView({
      behavior: 'smooth',
      block: block || 'start'
    });
  }


  /* ========================================
     STEP 1 — VEHICLE TYPE
     ======================================== */

  vehicleButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      clearSelected(vehicleButtons);
      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');

      state.vehicle = button.dataset.vehicle;

      if (state.vehicle === 'car') {
        state.vehicleLabel = 'Car';
      }

      if (state.vehicle === 'caravan') {
        state.vehicleLabel = 'Caravan';
      }

      if (state.vehicle === 'boat') {
        state.vehicleLabel = 'Boat';
      }

      resetAfterVehicleChange();
      hideVehicleOptions();

      if (state.vehicle === 'car') {
        showElement(carOptions);
      }

      if (state.vehicle === 'caravan') {
        showElement(caravanOptions);
      }

      if (state.vehicle === 'boat') {
        showElement(boatOptions);
      }

      updateSummary();
    });
  });


  /* ========================================
     CAR PACKAGE SELECTION
     ======================================== */

  priceButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      if (state.vehicle !== 'car') return;
      const group = button.dataset.screenGroup;
      if (!Object.prototype.hasOwnProperty.call(state.screens, group)) return;
      const wasSelected = state.screens[group] === button;
      priceButtons.forEach(function (other) {
        if (other.dataset.screenGroup === group) clearSelected([other]);
      });
      state.screens[group] = wasSelected ? null : button;
      if (!wasSelected) {
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
      }

      const selected = [state.screens.windscreens, state.screens.windows].filter(Boolean);
      state.package = selected.map(function (item) { return item.dataset.package; }).join(' + ') || null;
      state.packageIntakeValue = state.package;
      state.price = selected.length ? selected.reduce(function (sum, item) {
        return sum + Number(item.dataset.price);
      }, 0) : null;

      if (selected.length) {
        showLocationStep();
      } else {
        state.location = null;
        state.bookingFee = null;
        state.bookingType = null;
        clearSelected(locationButtons);
        hideElement(locationStep);
      }
      hideCalendars();
      updateSummary();
      updateBookingButton();
      preselectScreenPackage(document);
      // Keep the two groups in view while customers build their combination.
    });
  });


  /* ========================================
     CARAVAN / BOAT
     ======================================== */

  nonCarButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      state.package = button.dataset.package;
      state.packageIntakeValue = button.dataset.package;
      state.price = button.dataset.price;
      preselectScreenPackage(document);

      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');

      updateSummary();
      showLocationStep();
      updateBookingButton();

      window.setTimeout(function () {
        scrollToElement(locationStep, 'center');
      }, 100);
    });
  });


  /* ========================================
     STEP 2 — LOCATION
     ======================================== */

  locationButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      clearSelected(locationButtons);
      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');

      state.location = button.dataset.location;
      state.bookingFee = button.dataset.bookingFee;
      state.bookingType = button.dataset.bookingType;

      hideCalendars();

      updateSummary();
      updateBookingButton();

      if (bookingContinue) {
        window.setTimeout(function () {
          scrollToElement(bookingContinue, 'center');
        }, 100);
      }
    });
  });


  /* ========================================
     STEP 3 — SHOW CORRECT CALENDAR
     ======================================== */

  if (showCalendarButton) {
    showCalendarButton.addEventListener('click', function () {
      if (!isReadyToBook()) {
        return;
      }

      showElement(calendarWrapper);

      hideElement(workshopCalendar);
      hideElement(calloutCalendar);

      if (state.bookingType === 'workshop') {
        showElement(workshopCalendar);

        if (calendarDescription) {
          calendarDescription.textContent =
            'Select an available 20-minute appointment at our Nerang showroom.';
        }
      }

      if (state.bookingType === 'callout') {
        showElement(calloutCalendar);

        if (calendarDescription) {
          calendarDescription.textContent =
            'Select an available time for us to come to you within Brisbane or the Gold Coast.';
        }
      }

      window.setTimeout(function () {
        scrollToElement(calendarWrapper, 'start');
      }, 100);
    });
  }


  /* ========================================
     EASY APPOINTMENT BOOKING POPUP
     ========================================

     Easy Appointment Booking inserts its booking
     popup dynamically.

     This observer:
     1. Attempts to pre-select Screen Package.
     2. Hides the pointless attendee selector where
        the booking is locked to exactly one attendee.

     If Servicify changes its markup later, our core
     estimator/calendar still works independently.
     ======================================== */

  function normaliseText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();
  }


  function packageKey(value) {
    // Ignore the display-price suffix, but require the complete package name.
    // Substring matching would confuse individual packages with combinations.
    return normaliseText(value).replace(/\s*-\s*(?:from\s*)?\$[\d,.]+\s*$/, '').trim();
  }


  function preselectScreenPackage(root) {
    const selects = root.querySelectorAll('select');

    if (!selects.length) {
      return;
    }

    const wanted = packageKey(state.packageIntakeValue);

    selects.forEach(function (select) {
      let isScreenPackage = false;

      const id = select.id;

      if (id) {
        const label = root.querySelector(
          'label[for="' + CSS.escape(id) + '"]'
        );

        if (
          label &&
          normaliseText(label.textContent).includes('screen package')
        ) {
          isScreenPackage = true;
        }
      }

      if (!isScreenPackage) {
        const parentText = normaliseText(
          select.parentElement
            ? select.parentElement.textContent
            : ''
        );

        if (parentText.includes('screen package')) {
          isScreenPackage = true;
        }
      }

      if (!isScreenPackage) {
        return;
      }

      const options = Array.from(select.options);

      const matchingOption = wanted ? options.find(function (option) {
        return !option.disabled && packageKey(option.textContent) === wanted;
      }) : null;
      const placeholder = options.find(function (option) {
        return option.value === '' || /^(select|choose) (an? )?option/i.test(option.textContent.trim());
      });
      const target = matchingOption || placeholder;
      const targetIndex = target ? options.indexOf(target) : -1;
      if (select.selectedIndex === targetIndex) return;

      // Clear stale selections if the required combination has not been added to the app.
      select.selectedIndex = targetIndex;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      select.dispatchEvent(new Event('input', { bubbles: true }));

    });
  }


  function hideAttendeeSelector(root) {
    const candidates = root.querySelectorAll(
      'div, section, fieldset'
    );

    candidates.forEach(function (element) {
      const text = normaliseText(element.textContent);

      if (
        !text.includes(
          'how many people will be attending this event'
        )
      ) {
        return;
      }

      /*
       * Find the smallest sensible wrapper rather than
       * hiding the entire modal.
       */
      const childContainsSameText = Array.from(
        element.children
      ).some(function (child) {
        return normaliseText(child.textContent).includes(
          'how many people will be attending this event'
        );
      });

      if (!childContainsSameText) {
        element.style.display = 'none';
      }
    });
  }


  function enhanceBookingPopup() {
    preselectScreenPackage(document);
    hideAttendeeSelector(document);
  }


  let popupEnhancementPending = false;
  const bookingObserver = new MutationObserver(function () {
    if (popupEnhancementPending) return;
    popupEnhancementPending = true;
    window.requestAnimationFrame(function () {
      popupEnhancementPending = false;
      enhanceBookingPopup();
    });
  });

  bookingObserver.observe(document.body, {
    childList: true,
    subtree: true
  });


  /* ========================================
     INITIAL STATE
     ======================================== */

  hideVehicleOptions();
  hideElement(locationStep);
  hideElement(bookingContinue);
  hideCalendars();

  const defaultVehicle = Array.from(vehicleButtons).find(function (button) {
    return button.dataset.vehicle === 'car';
  });
  if (defaultVehicle) defaultVehicle.click();
  updateSummary();
});